<template>
  <div class="cb-device-test dark-theme">
    <div class="cb-device-test__container">
      <button
        id="open-nav"
        aria-label="Open Navigation"
        @click="handleNavButtonClick"
        class="nav-button"
      >
        <img alt src="../assets/icons/menu-icon-white.svg" />
      </button>
      <cb-navigation v-if="isNavigationOpen"></cb-navigation>
      <component :is="deviceTestStep"></component>
    </div>
  </div>
</template>

<script>
/* global gtag */
import { mapState, mapMutations } from 'vuex';
import DeviceTestFetch from '../components/DeviceTestFetch.vue';
import DeviceTestSuccess from '../components/DeviceTestSuccess.vue';
import Navigation from '../components/NavigationModal.vue';

export default {
  methods: {
    handleNavButtonClick() {
      this.setIsNavigationModalOpen(true);
      gtag('event', 'openNavClick', {
        event_label: 'open navigation',
        event_category: 'deviceTest',
        value: 1,
      });
    },
    ...mapMutations(['setIsNavigationModalOpen']),
  },
  computed: {
    ...mapState({
      isNavigationOpen: (state) => state.navigationModal.isOpen,
      deviceTestStep: (state) => state.deviceTestStep,
      modal: (state) => state.modal,
    }),
  },
  beforeRouteLeave(to, from, next) {
    if (this.modal.isOpen && this.modal.modalContent === 'cbAuth') {
      next(false);
    } else {
      next();
    }
  },
  components: {
    cbDeviceTestFetch: DeviceTestFetch,
    cbDeviceTestSuccess: DeviceTestSuccess,
    cbNavigation: Navigation,
  },
};
</script>

<style lang="scss" scoped>
.cb-device-test {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: $azure;
  min-height: 100vh;
  width: 100vw;
  box-sizing: border-box;

  &__container {
    width: 100%;

    .nav-button {
      position: absolute;
      border: 0;
      padding: 0;
      top: 20px;
      right: 20px;
      background-color: transparent;
      height: 24px;
      width: 24px;

      img {
        height: 100%;
        width: 100%;
      }
    }
  }

  @include desktop {
    background-color: unset;
    padding: 20px;
    justify-content: center;
    box-sizing: border-box;

    &__container {
      position: relative;
      background-color: $azure;
      box-sizing: border-box;
      height: 574px;
      max-width: 1113px;
    }
  }
}
</style>
